import Emittery from 'emittery';
import { id, } from '@volkswagen-onehub/gfa-auth-service';
import { AuthServiceProviderV4 } from './v4/AuthServiceProviderV4';
export * from './v4/AuthServiceProviderV4';
export * from './v4/AuthServiceV4';
export * from './v4/types';
// (!) Keep in sync with README and feature-service-types.ts!
const requiredFeatureServices = {
    /* eslint-disable @typescript-eslint/naming-convention */
    'locale-service': '^1.0.0',
    /* eslint-disable @typescript-eslint/naming-convention */
};
// (!) Keep in sync with README and feature-service-types.ts!
const optionalFeatureServices = {
    's2:logger': '^1.0.0',
};
const sharedState = {
    authServiceState: new Map(),
    eventEmitter: new Emittery(),
};
/**
 * Small helper to easily define an AuthServiceProvider for your personal FeatureHub
 * @param options
 */
export function defineAuthService(options) {
    return {
        id: 'vw:authService',
        dependencies: {
            featureServices: requiredFeatureServices,
        },
        optionalDependencies: {
            featureServices: optionalFeatureServices,
        },
        create: (env) => {
            const localeService = env.featureServices['locale-service'];
            const logger = env.featureServices['s2:logger'] || console;
            const authServiceProviderV4 = new AuthServiceProviderV4(Object.assign({ authProxyFormMyaudiResourceHostId: 'form-myaudi' }, options), sharedState, localeService, logger);
            return {
                '4.0.0': () => ({ featureService: authServiceProviderV4 }),
            };
        },
    };
}
export function defineGfaAuthService() {
    return {
        id,
        dependencies: {
            featureServices: {
                'vw:authService': '^4.0.0',
            },
        },
        create: (env) => {
            const authService = env.featureServices['vw:authService'];
            return {
                '2.0.0': () => ({
                    featureService: authService,
                }),
            };
        },
    };
}
//# sourceMappingURL=index.js.map